var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('auto-table',{attrs:{"DataList":_vm.DataList,"option":_vm.Option,"total":_vm.Total},on:{"changePage":_vm.getList},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(_vm._s(_vm.type[row.type]))])]}},{key:"handle",fn:function(ref){
var row = ref.row;
return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.details(row)}}},[_vm._v("物业详情")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }